<!-- WonderYjjRate.vue -->
<template>
	<div>
		<div class="row">
			<template v-if="days.length">
				<RatePlate v-for="(day, index) in days" :date1="day" :key="index" :plate_type=17
					:selectedPlateCode="selectedPlateCode" :selectedPlateName="selectedPlateName" @plate-selected="handlePlateSelected">
				</RatePlate>
			</template>
		</div>
		<div class="row">
			<div class="col col-xl-3 col-lg-3 col-md-4 col-sm-6" v-if="selectedPlateCode">
				<!-- <PlateStockPopular :plate_type=17 :plate_code="selectedPlateCode" :p_date=selectedDate @p_show_kline="handleShowKline" @date-selected="handleDateSelected"></PlateStockPopular> -->
				<PlateStockPopularTable  :plate_type=17 :plate_code="selectedPlateCode" :p_date=selectedDate @p_show_kline="handleShowKline" @date-selected="handleDateSelected" />
			</div>
			<div class="col col-xl-9 col-lg-9 col-md-8 col-sm-6">
				<StockKlineDay v-if="selectedPlateCode" :symbol_code="selectedPlateCode" :title="selectedPlateName" :subText="selectedPlateCode" :highlightDate="selectedDate" :chart_heigh="'400px'" :zoom_start=40></StockKlineDay>

				<StockMultiChart v-if="symbol_code" :symbol_code="symbol_code" :symbol_name="symbol_name" :selectedDate="selectedDate"
					:chart_width="'900px'">
				</StockMultiChart>

			</div>
		</div>
	</div>
</template>

<script>
	import YjjMixin from '../../mixins/views/wonder/YjjMixin.js'

	export default {
		mixins: [YjjMixin]
	}
</script>

<style>
</style>